import { Directive, ElementRef, HostListener, Input } from '@angular/core'
import copyToClipboard from 'copy-text-to-clipboard'
import './copyToClipboardButton.directive.scss'

@Directive({
  selector: '[copyToClipboardButton]',
})
export class CopyToClipboardButtonDirective {
  @Input() styling = true
  @Input('copyToClipboardButton') text: string | (() => string)
  @Input() successClass = 'bg-success'
  busy = false

  constructor (
    private element: ElementRef<HTMLElement>,
  ) { }

  @HostListener('click') onClick () {
    if (this.busy) {
      return
    }

    let value = this.text
    if (value instanceof Function) {
      value = value()
    }
    copyToClipboard(value)

    const element = this.element.nativeElement

    if (this.styling) {
      this.busy = true
      const oldContent = element.innerHTML
      element.classList.toggle(this.successClass, true)
      element.innerHTML = '<i class="far fa-fw fa-check"></i>'
      setTimeout(() => {
        element.innerHTML = oldContent
        element.classList.toggle(this.successClass, false)
        this.busy = false
      }, 2000)
    }
  }
}
